import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";

import App from "./components/App/App";
import configureStore from "./redux/configureStore";
import {unregister} from "./registerServiceWorker";
import "bootstrap/scss/bootstrap.scss";
import {AppContainer} from "react-hot-loader";
import {BrowserRouter as Router, Route, withRouter} from "react-router-dom";
import {BreadcrumbsProvider} from "react-breadcrumbs-dynamic";

const store = configureStore();

const root = document.createElement("div");
document.body.appendChild(root);

const render = (component: any) => {
  ReactDOM.render(
    <>
      <Provider store={store}>
        <BreadcrumbsProvider>
          <Router basename={process.env.PUBLIC_URL}>
          <Route path="/" component={component}/>
          </Router>
        </BreadcrumbsProvider>
      </Provider>
    </>,
    root,
  );
};

render(withRouter(App));

unregister();
